import React from 'react';

import cx from 'classnames';

import {
	SuccessIcon,
	ExclamationFilledIcon,
	BusinessLogo,
} from '@shared/assets';

import { IProductActivationStepper, StepperState } from '@shared/types';
import styles from './ProductActivationStepper.module.scss';
import { PG_STEPPER_STATE } from '@shared/constants';

const ProductActivationStepper = ({
	header,
	description,
	steps = {},
}: IProductActivationStepper) => {
	const getStepperIcon = (state: string) => {
		switch (state) {
			case StepperState.COMPLETED:
				return (
					<div className={cx(styles.stepCircle, styles.completedCircle)}>
						<SuccessIcon />
					</div>
				);
			case StepperState.IN_PROGRESS:
				return (
					<div className={cx(styles.stepCircle, styles.stepCircleActive)}>
						<span></span>
					</div>
				);
			case StepperState.ERROR:
				return (
					<div className={cx(styles.stepCircle, styles.stepCircleError)}>
						<ExclamationFilledIcon />
					</div>
				);
			case StepperState.PSEUDO_SUCCESS:
				return (
					<div className={cx(styles.stepCircle, styles.stepCircleWarning)}>
						<ExclamationFilledIcon />
					</div>
				);
			default:
				return (
					<div className={styles.stepCircle}>
						<span></span>
					</div>
				);
		}
	};

	return (
		<div className={styles.productStepperContainer}>
			<div className={styles.logoContainer}>
				<BusinessLogo className={styles.businessLogo} />
			</div>
			<div className={styles.mainContent}>
				<div className={styles.infoContainer}>
					{header && <p className={styles.header}>{header}</p>}
					{description && <p className={styles.description}>{description}</p>}
				</div>
				<div className={styles.stepperListing}>
					{Object.keys(steps).map(
						(step) =>
							steps[step].stepVisible && (
								<div
									key={step}
									className={cx(styles.stepContainer, {
										[styles.stepActive]:
											steps[step].status === PG_STEPPER_STATE.IN_PROGRESS,
									})}
								>
									{getStepperIcon(steps[step].status)}
									<div className={styles.stepContent}>
										<p className={styles.stepHeader}> {steps[step].header} </p>
										{steps[step].description && (
											<p className={styles.stepDesc}>
												{steps[step].description}
											</p>
										)}
										{steps[step].infoCard && (
											<div className={styles.stepExtraInfo}>
												<div>
													<p className={styles.infoHeader}>
														{steps[step].infoCard?.header}
													</p>
													<p className={styles.infoDesc}>
														{steps[step].infoCard?.description}
													</p>
												</div>
											</div>
										)}
									</div>
								</div>
							),
					)}
				</div>
			</div>
		</div>
	);
};

export default ProductActivationStepper;
